import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=735641ed&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"
import style0 from "./Popup.vue?vue&type=style&index=0&id=735641ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735641ed",
  null
  
)

export default component.exports